import React from "react";
import { observer } from "mobx-react";
import Modal from "../Modal/Modal";
import { globalPopupStore } from "@stores/main";
import styles from "./GlobalPopup.module.scss";

const GlobalPopup: React.FC = observer(() => {
  return (
    <Modal
      isOpen={globalPopupStore.isVisible}
      onClose={() => globalPopupStore.hide()}
    >
      <section className={styles.popup}>
        <button
          type="button"
          className={styles.popupClose}
          onClick={() => globalPopupStore.hide()}
          aria-label="Close"
        >
          <i className="fas fa-times" aria-hidden />
        </button>
        <div className={styles.popupBody}>
          <div className={styles.popupIcon}>
            <i className="fas fa-exclamation-circle" aria-hidden />
          </div>
          <p className={styles.popupMessage}>{globalPopupStore.message}</p>

          {globalPopupStore.onContinue && (
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={globalPopupStore.onContinue}
            >
              Continue
            </button>
          )}

          <button
            type="button"
            className={globalPopupStore.onContinue ? styles.secondaryBtn : styles.primaryBtn}
            onClick={() => globalPopupStore.hide()}
          >
            {globalPopupStore.onContinue ? "Cancel" : "OK"}
          </button>
        </div>
      </section>
    </Modal>
  );
});

export default GlobalPopup;
